import { LoadingOutlined } from "@ant-design/icons";
import { Button, Flex, Form, Modal, Row, Space, Upload } from "antd";
import { getBase64 } from "components/elements/upload/Upload.utils";
import FormAntd from "components/form/FormProvide/FormAntd";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { dataURLtoFile } from "utils/helper";
import { ReactComponent as UploadIcon } from "../../../assets/icon/uploadIcon.svg";
import * as service from "../services/employeeApi";
import styles from "../styles/EmployeeForm.module.css";

function EmployeeImageProfileModal({
    isModalOpen = false,
    handleOk = () => { },
    handleCancel = () => { },
    initialValues = {},
    imageUrl = {},
    setImageUrl = {},
    onImageSubmit = () => { },
    permissions
}) {
    const { t, i18n } = useTranslation();
    const [loading, setLoading] = useState(false);
    const [tempImageUrl, setTempImageUrl] = useState("");

    useEffect(() => {
        if (isModalOpen && imageUrl) {
            setTempImageUrl(imageUrl);
        }
    }, [isModalOpen, imageUrl]);

    const uploadButton = (
        <button
            style={{
                border: 0,
                background: "none",
            }}
            type="button"
        >
            {loading ? <LoadingOutlined /> : <UploadIcon />}
            <Flex vertical justify="center" align="center" style={{ rowGap: "4px" }}>
                <span style={{ fontSize: "1.2vw", color: "#42526D" }}>{t("common.upload")}</span>
                <span style={{ color: "#42526D" }}>{i18n.language === "en" ? "Recommend image size : 500 × 500 px (max is 2 MB)" : "ขนาดไฟล์รูปภาพที่แนะนำ : 500 × 500 px (ไม่เกิน 2 MB)"}</span>
            </Flex>

        </button>
    );

    const beforeUpload = (file) => {
        return false;
    };

    return (
        <Modal
            title={t("employee.label.edit_profile_pic")}
            open={isModalOpen}
            closable={false}
            maskClosable={false}
            destroyOnClose
            footer={null}
        >
            <FormAntd initialValues={initialValues} onFinish={handleOk}>
                <Form.Item shouldUpdate>
                    {({ getFieldValue, setFieldValue }) => {
                        const onAvatarChange = async (info) => {
                            setLoading(true);
                            const compressImg = await service.compressedImage({
                                file: info.file
                            })
                            getBase64(compressImg.data, (url) => {
                                console.log("url2 ", url);
                                setLoading(false);
                                setFieldValue("employeeImage", dataURLtoFile(url));
                                setTempImageUrl(url);
                            });
                        };

                        return (
                            <Flex vertical style={{ gap: "24px" }}>
                                <Upload
                                    name="employeeImage"
                                    listType="picture-card"
                                    className={styles.avatarUploaderEdit}
                                    showUploadList={false}
                                    beforeUpload={beforeUpload}
                                    onChange={onAvatarChange}
                                    action={null}
                                >
                                    {tempImageUrl ? (
                                        <>
                                            <img
                                                src={tempImageUrl}
                                                alt="avatar"
                                                // className={styles.avatarImage}
                                                style={{
                                                    width: "100%",
                                                    height: "100%",
                                                    objectFit: "contain",
                                                    borderRadius: "8px"
                                                }}
                                            />
                                        </>
                                    ) : (
                                        uploadButton
                                    )}
                                </Upload>

                                <Row justify="end" style={{ width: "100%" }}>
                                    <Space direction="horizontal" size={10}>
                                        <Button
                                            id="cancelBtn"
                                            type="default"
                                            onClick={handleCancel}
                                            style={{ borderRadius: 8, padding: "8px 16px", height: "40px" }}
                                        >
                                            {t("common.cancel").toUpperCase()}
                                        </Button>

                                        <Button htmlType="submit"
                                            type="primary"
                                            style={{ borderRadius: 8, padding: "8px 16px", height: "40px", backgroundColor: "var(--button-color)" }}
                                        >
                                            {t("common.submit").toUpperCase()}
                                        </Button>
                                    </Space>
                                </Row>
                            </Flex>
                        )
                    }}
                </Form.Item>
            </FormAntd>
        </Modal >
    )
}

export default EmployeeImageProfileModal;